import { z } from 'zod';
import { MoneySchema } from './common.js';
// ============================================================
// AssetCategory — per-company configurable asset class with
// default useful life, salvage, and 5 GL account codes wired
// into the Fixed Asset acquisition / depreciation / disposal JVs.
// Defaults are the real 8-digit COA codes from the master migration.
// ============================================================
export const AssetCategorySchema = z.object({
    id: z.uuid(),
    companyId: z.uuid(),
    code: z.string().min(1).max(64),
    nameTh: z.string().min(1),
    nameEn: z.string().nullable().optional(),
    defaultLifeMonths: z.number().int().positive(),
    defaultSalvage: z.union([MoneySchema, z.coerce.number().nonnegative()]),
    glCostCode: z.string().min(1).max(20).default('10220001'),
    glAccDepCode: z.string().min(1).max(20).default('10280002'),
    glDepExpenseCode: z.string().min(1).max(20).default('60110061'),
    glDisposalGainCode: z.string().min(1).max(20).default('40130012'),
    glDisposalLossCode: z.string().min(1).max(20).default('40130012'),
    isActive: z.boolean(),
    createdAt: z.coerce.date(),
    updatedAt: z.coerce.date(),
});
export const CreateAssetCategorySchema = AssetCategorySchema.omit({
    id: true,
    createdAt: true,
    updatedAt: true,
});
export const UpdateAssetCategorySchema = CreateAssetCategorySchema.partial().omit({
    companyId: true,
});
//# sourceMappingURL=asset-category.js.map